const DEFAULT_LOCALE = 'lt-ru';

const LOCAL_STORAGE_STATE_KEY = 'LOCAL_STORAGE_STATE_KEY';
const LOCAL_STORAGE_BEARER_TOKEN_KEY = 'BEARER_TOKEN';

const isProd = process.env.NODE_ENV === 'production';
const API_SCHEME = isProd ? 'https': 'http';
const API_HOST = isProd ? 'api.translate.hitrov.com' : 'localhost';
const API_PORT = isProd ? '443' : '3000';

const GET_BEARER_TOKEN_REQUEST = 'GET_BEARER_TOKEN_REQUEST';
const GET_BEARER_TOKEN_SUCCESS = 'GET_BEARER_TOKEN_SUCCESS';
const GET_BEARER_TOKEN_FAILURE = 'GET_BEARER_TOKEN_FAILURE';

const SET_BEARER_TOKEN_REQUEST = 'SET_BEARER_TOKEN_REQUEST';
const SET_BEARER_TOKEN_SUCCESS = 'SET_BEARER_TOKEN_SUCCESS';

const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

const GET_WORD_PAIR_REQUEST = 'GET_WORD_PAIR_REQUEST';
const GET_WORD_PAIR_SUCCESS = 'GET_WORD_PAIR_SUCCESS';
const GET_WORD_PAIR_FAILURE = 'GET_WORD_PAIR_FAILURE';

const SET_REMEMBERED = 'SET_REMEMBERED';
const SET_FORGOTTEN = 'SET_FORGOTTEN';

const REMEMBER_REQUEST = 'REMEMBER_REQUEST';
const REMEMBER_SUCCESS = 'REMEMBER_SUCCESS';
const REMEMBER_FAILURE = 'REMEMBER_FAILURE';

const FORGET_REQUEST = 'FORGET_REQUEST';
const FORGET_SUCCESS = 'FORGET_SUCCESS';
const FORGET_FAILURE = 'FORGET_FAILURE';

const TOGGLE_REMEMBERED = 'TOGGLE_REMEMBERED';
const TOGGLE_SHOW_TRANSLATION = 'SHOW_TRANSLATION';

const HEADER_AUTHORIZATION = 'Authorization';

export {
  DEFAULT_LOCALE,

  LOCAL_STORAGE_STATE_KEY,
  LOCAL_STORAGE_BEARER_TOKEN_KEY,

  API_SCHEME,
  API_HOST,
  API_PORT,

  GET_BEARER_TOKEN_REQUEST,
  GET_BEARER_TOKEN_SUCCESS,
  GET_BEARER_TOKEN_FAILURE,

  GET_WORD_PAIR_REQUEST,
  GET_WORD_PAIR_SUCCESS,
  GET_WORD_PAIR_FAILURE,

  REMEMBER_REQUEST,
  REMEMBER_SUCCESS,
  REMEMBER_FAILURE,

  FORGET_REQUEST,
  FORGET_SUCCESS,
  FORGET_FAILURE,

  SET_REMEMBERED,
  SET_FORGOTTEN,

  TOGGLE_REMEMBERED,
  TOGGLE_SHOW_TRANSLATION,

  HEADER_AUTHORIZATION,

  SET_BEARER_TOKEN_REQUEST,
  SET_BEARER_TOKEN_SUCCESS,

  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
};
